import { render, staticRenderFns } from "./profileAction.vue?vue&type=template&id=6e107042"
import script from "./profileAction.vue?vue&type=script&lang=js"
export * from "./profileAction.vue?vue&type=script&lang=js"
import style0 from "./profileAction.vue?vue&type=style&index=0&id=6e107042&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports